import { useEffect, useState } from "react";
import { usePlantUI } from "../../../../biz/hooks/usePlantHooks";
import { CHANGE_ORGANIZATION_OFFERS, CHANGE_ORGANIZATION_PLANTASSORTMENT, OrganizationOfferStateType, OrganizationOfferType, OrganizationOfferTypeType } from "../../../../biz/data/redux/organizationReducer";
import { useDispatch, useSelector } from "react-redux";
import { RdxType, RestItemContainer, RestListContainer, RestResponseType, StringStringDictionary } from "../../../../biz/data/Types";
import { useDialogs } from "../MesssageBoxes";
import { useOrganization } from "../../../../biz/hooks/entities/useOrganization";
import { useFetcher } from "react-router-dom";
import { useFetch } from "../../../../biz/hooks/data/useFetcher";
import { DataHelper, Helpers } from "../../../../biz/data/Helpers";
import { AssortmentsUITabStateType, CHANGE_UI_ASSORTMENTS } from "../../../../biz/data/redux/uIReducer";

// Offer = Erbjudande / Assortments = Utbud
export const useSimpleAssortments = () => {
    const plantUI = usePlantUI();
    const data = useAssortmentsData();
    const dialogs = useDialogs();
    const currentOrganization = useOrganization().currentOrganization;
    const assortmentsUI = useSelector((state: RdxType) => state.ui.assortmentsUI);
    const dispatch = useDispatch();
    return {
        uiTabState: assortmentsUI?.uiTabState ?? "offer",
        setUiTabState: (e: AssortmentsUITabStateType) => {
            const b = { ...assortmentsUI, uiTabState: e };
            dispatch({ type: CHANGE_UI_ASSORTMENTS, payload: b });
        },
        loadOffers: (organizationId: string) => data.loadOffers(organizationId),
        currentOrganization: currentOrganization,
        offers: data.getOffersList(),
        selection: data.getSelectionList(),
        plants: data.getPlantList(),
        plantLinks: data.plantLinks,
        plantsDb: data.plantsDb,
        updateOfferSorting: data.updateOfferSorting,
        updateOffer: data.updateOffer,
        removePlantFromAssortment: async (plantId: string) => {
            return await data.removePlantFromAssortment(currentOrganization?.id ?? "", plantId);
        },
        setPlantLink: async (plantId: string, url: string) => {
            return await data.setPlantLink(currentOrganization?.id ?? "", plantId, url);
        },
        onAddOfferPress: async (type: OrganizationOfferTypeType) => {

            if (type === "offer" && data.getOffersList().length === 3) {
                dialogs.showInfo("Max 3", "Ditt utbud visas på din profilsida och är tänkt fungera som ett skyltfönster, och bör endast visa ett axplock av de varor eller tjänster du erbjuder.")
                return;
            }
            if (type === "selection" && data.getSelectionList().length === 10) {
                dialogs.showInfo("Max 10", "Ditt utbud visas på din profilsida och är tänkt fungera som ett skyltfönster, och bör endast visa ett axplock av de varor eller tjänster du erbjuder.")
                return;
            }

            let _offers = data.getOffersList().map((m, idx) => { return { ...m, sorting: idx } });
            let _assortments = data.getSelectionList().map((m, idx) => { return { ...m, sorting: idx } });
            data.updateOffers([..._offers, ..._assortments]);

            data.addOffer({
                type: type,
                id: new Date().valueOf().toString(),
                state: "draft", name: "New .....",
                sorting: data.getNewFirstSorting(),
                organizationId: currentOrganization?.id ?? "",
                organizationName: currentOrganization?.name ?? "",
                title01: "", title02: "", title03: "", link: "",
                imageid: "", imageUrl: "", imageUrlThumb: "",
                editing: true
            });
        },
        updateOfferState: data.updateOfferState,
    }
}

export const useAssortmentsData = () => {
    const dispatch = useDispatch();
    const offers = useSelector((state: RdxType) => state.organization.myOffers);
    const plants = useSelector((state: RdxType) => state.organization.myPlantAssortment);
    const api = useAssortmentsDataApi();

    const loadOffers = async (organizationId: string) => {
        const { items, success } = await api.getOffers(organizationId);
        let change: { [x: string]: OrganizationOfferType } = {};
        items.forEach(e => change[e?.id] = e);
        dispatch({ type: CHANGE_ORGANIZATION_OFFERS, payload: change });

        let pass = await api.getOrganizationPlants(organizationId);
        Object.keys(pass ?? {}).filter(key => DataHelper.isGuid(key) == false).forEach(key => { delete pass[key] });
        dispatch({ type: CHANGE_ORGANIZATION_PLANTASSORTMENT, payload: pass });
    }

    return {
        plantLinks: plants,
        loadOffers: loadOffers,
        upsertOffer: async (organizationId: string, e: OrganizationOfferType, file?: File) => {
            await api.upsertOffer(organizationId, e, file);
            await loadOffers(organizationId);
        },
        offersDb: offers,
        plantsDb: plants,
        getOffersList: () => {
            let lst = Object.keys(offers ?? {}).map(key => offers?.[key])
                .filter(m => !!m).filter(m => m?.type == "offer");
            lst.sort((a, b) => {
                if ((a.sorting ?? 0) > (b.sorting ?? 0)) { return 1; }
                else if ((a.sorting ?? 0) < (b.sorting ?? 0)) { return -1; }
                else { return 0; }
            });
            return lst ?? [];
        },
        getSelectionList: () => {
            let lst = Object.keys(offers ?? {}).map(key => offers?.[key])
                .filter(m => !!m).filter(m => m?.type == "selection");
            lst.sort((a, b) => {
                if ((a.sorting ?? 0) > (b.sorting ?? 0)) { return 1; }
                else if ((a.sorting ?? 0) < (b.sorting ?? 0)) { return -1; }
                else { return 0; }
            });
            return lst ?? [];
        },
        getPlantList: () => {
            let lst = Object.keys(plants ?? {});
            return lst ?? [];
        },
        updateOffers: (e: OrganizationOfferType[]) => {
            let change: { [x: string]: OrganizationOfferType } = {};
            e.forEach(m => change[m.id ?? ""] = m);
            dispatch({ type: CHANGE_ORGANIZATION_OFFERS, payload: change });
        },
        updateOfferSorting: (organizationId: string, e: OrganizationOfferType[]) => {
            let change = { ...offers };
            e.forEach(m => change[m.id ?? ""].sorting = m?.sorting);
            dispatch({ type: CHANGE_ORGANIZATION_OFFERS, payload: change });
            api.updateSorting(organizationId, e)
        },
        updateOfferBoost: (organizationId: string, id: string, boostedUntil: number) => {
            let change = { ...offers };
            if (change?.[id]?.id) {
                change[id].boostedUntilDatekey = boostedUntil;
            }
            dispatch({ type: CHANGE_ORGANIZATION_OFFERS, payload: change });
            api.updateOfferBoost(organizationId, id, boostedUntil);
        },
        getNewFirstSorting: () => {
            let lst = Object.keys(offers ?? {}).map(key => offers?.[key]?.sorting);
            lst.sort((a, b) => a - b);
            return (lst?.[0] ?? 0) - 1;
        },
        updateOffer: (e: OrganizationOfferType) => {
            let change = { ...offers };
            change[e.id ?? ""] = { ...e };
            dispatch({ type: CHANGE_ORGANIZATION_OFFERS, payload: change });
        },
        updateOfferState: async (organizationId: string, id: string, state: OrganizationOfferStateType) => {
            let bak = { ...offers };
            let change = { ...offers };
            if (!!change[id]) {
                change[id].state = state;
            }
            dispatch({ type: CHANGE_ORGANIZATION_OFFERS, payload: change });
            const ret = await api.updateOfferState(organizationId, id, state);
            if (!ret.success) {
                dispatch({ type: CHANGE_ORGANIZATION_OFFERS, payload: bak });
            }
        },
        addOffer: (e: OrganizationOfferType) => {
            let change = { ...offers, [e?.id ?? ""]: e };
            dispatch({ type: CHANGE_ORGANIZATION_OFFERS, payload: change });
        },
        setEditItem: (id: string, editing: boolean) => {
            let change = { ...offers };
            if (!!change[id]) {
                change[id].editing = editing;
                dispatch({ type: CHANGE_ORGANIZATION_OFFERS, payload: change });
            }
        },
        removeItem: async (organizationId: string, offerId: string) => {
            await api.deleteOffer(organizationId, offerId);
            await loadOffers(organizationId);
        },
        setPlantAssortment: async (organizationId: string, ids: string[]) => {
            let change: ChangeOrganizationPlantsArgsType = {
                add: [],
                remove: []
            };
            ids.filter(id => !plants?.[id]).forEach(id => change.add.push(id));
            Object.keys(plants ?? {}).filter(id => ids.indexOf(id) < 0).forEach(id => change.remove.push(id));
            await api.changeOrganizationPlants(organizationId, change);
            await loadOffers(organizationId);
        },
        removePlantFromAssortment: async (organizationId: string, id: string) => {
            let change: ChangeOrganizationPlantsArgsType = {
                remove: [id], add: []
            };
            await api.changeOrganizationPlants(organizationId, change);
            await loadOffers(organizationId);
        },
        setPlantLink: async (organizationId: string, id: string, url: string) => {
            let change: StringStringDictionary = { [id]: url };
            await api.changeOrganizationPlantUrl(organizationId, change);
            await loadOffers(organizationId);
        }
    }
}

const useAssortmentsDataApi = () => {
    const f = useFetch();

    return {
        getOffers: async (organizationId: string): Promise<RestListContainer<OrganizationOfferType>> => {
            return await f.get("/api/organization/" + organizationId + "/offers");
        },
        upsertOffer: async (organizationId: string, e: OrganizationOfferType, file?: File): Promise<RestResponseType> => {
            let formData: FormData = new FormData();
            formData.append('file', file as File);
            formData.append('json', JSON.stringify(e));
            formData.forEach(function (value: any, key: string) {
                console.log("formData:", key, JSON.stringify(value));
            });

            return await f.postForm("/api/organization/" + organizationId + "/offers/" + (e?.id ?? "none"), formData);
        },
        deleteOffer: async (organizationId: string, offerId: string): Promise<RestResponseType> => {
            return await f.delete("/api/organization/" + organizationId + "/offers/" + offerId);
        },
        updateSorting: async (organizationId: string, e: OrganizationOfferType[]) => {
            return await f.patch("/api/organization/" + organizationId + "/offers/sorting", {
                sort: e?.map(m => {
                    return {
                        id: m?.id,
                        sorting: m?.sorting
                    }
                })
            });
        },
        updateOfferBoost: async (organizationId: string, offerId: string, boostedUntil: number): Promise<RestResponseType> => {
            const p = { boostedUntil: boostedUntil };
            return await f.patch("/api/organization/" + organizationId + "/offers/" + offerId + "/boost", p);
        },
        updateOfferState: async (organizationId: string, offerId: string, state: OrganizationOfferStateType): Promise<RestResponseType> => {
            const p = { state: state };
            return await f.patch("/api/organization/" + organizationId + "/offers/" + offerId + "/state", p);
        },
        getOrganizationPlants: async (organizationId: string): Promise<StringStringDictionary> => {
            const res: RestItemContainer<StringStringDictionary> = await f.get("/api/organization/" + organizationId + "/plants");
            return res?.item;
        },
        changeOrganizationPlants: async (organizationId: string, change: ChangeOrganizationPlantsArgsType): Promise<StringStringDictionary> => {
            const res: RestItemContainer<StringStringDictionary> = await f.post("/api/organization/" + organizationId + "/plants", change);
            return res?.item;
        },
        changeOrganizationPlantUrl: async (organizationId: string, change: StringStringDictionary): Promise<StringStringDictionary> => {
            const res: RestItemContainer<StringStringDictionary> = await f.patch("/api/organization/" + organizationId + "/plantlinks", change);
            return res?.item;
        }
    }
}

type ChangeOrganizationPlantsArgsType = {
    add: string[],
    remove: string[]
}